"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabel = exports.getLink = exports.isExternalPage = exports.isPageUrl = void 0;
const assert_1 = require("../../assert");
const externalRegex = /^(http|https):\/\/(.*)/;
const pageUrlRegex = /^\/([^ ?#]*)[?]?(.*)/;
const isPageUrl = (url) => pageUrlRegex.test(url);
exports.isPageUrl = isPageUrl;
const isExternalPage = (url) => externalRegex.test(url);
exports.isExternalPage = isExternalPage;
const getLink = ({ link, target, linkUtils, }) => {
    if (!assert_1.assert.isNil(link)) {
        const passedTarget = (target ||
            (exports.isExternalPage(link) ? '_blank' : '_self'));
        return linkUtils.getLinkProps(link, passedTarget);
    }
    return {};
};
exports.getLink = getLink;
const getPageTitleFromUrl = (url, pageList) => {
    var _a;
    const key = url.slice(1);
    if (pageList.hasOwnProperty(key)) {
        return (_a = pageList[key]) === null || _a === void 0 ? void 0 : _a.title;
    }
    return undefined;
};
const getLabel = ({ link, label, pageList, }) => {
    if (!assert_1.assert.isNil(label)) {
        return label;
    }
    if (!assert_1.assert.isNil(link) && exports.isPageUrl(link)) {
        return getPageTitleFromUrl(link, pageList);
    }
    return undefined;
};
exports.getLabel = getLabel;
//# sourceMappingURL=utils.js.map